import { render, staticRenderFns } from "./ProductGroupsDetail.vue?vue&type=template&id=c03a3704&scoped=true&lang=html"
import script from "./ProductGroupsDetail.vue?vue&type=script&lang=js"
export * from "./ProductGroupsDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductGroupsDetail.vue?vue&type=style&index=0&id=c03a3704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03a3704",
  null
  
)

export default component.exports